import { GridColumnConfig } from '../../../../models/gridCoumnConfig';

export const columns: GridColumnConfig[] = [
  {
    title: 'Service Name',
    field: 'serviceName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Predecessor',
    field: 'predecessorNames',
    filter: 'text',
  },

  {
    title: 'Billing Type',
    field: 'billingType',
    filter: 'text',
  },
  {
    title: 'Service Group',
    field: 'serviceGroupName',
    filter: 'text',
    searchable: true,
    width: '200',
  },
  // {
  //   title: 'Forecast Days',
  //   field: 'forecastDays',
  //   filter: 'text',
  // },

  // {
  //   title: 'Invoice Amount ($)',
  //   field: 'price',
  //   filter: 'text',
  //   fieldType: 'currency',
  // },
];
